import React from 'react';

interface ExclusionChipProps {
  phone?: string; // For group and direct types
  groupName?: string; // For group-by-name type
  reason?: string;
  onRemove: () => void;
  type: 'group' | 'direct' | 'group-by-name';
}

export const ExclusionChip: React.FC<ExclusionChipProps> = ({
  phone,
  groupName,
  reason,
  onRemove,
  type
}) => {
  // For group-by-name, use different colors
  const isGroupByName = type === 'group-by-name';

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.5rem 0.75rem',
      background: isGroupByName ? '#f0fdf4' : (type === 'group' ? '#fef3c7' : '#dbeafe'),
      border: `1px solid ${isGroupByName ? '#10b981' : (type === 'group' ? '#f59e0b' : '#3b82f6')}`,
      borderRadius: '20px',
      margin: '0.25rem',
      fontSize: '0.85rem'
    }}>
      <span style={{ fontWeight: '500' }}>
        {isGroupByName ? '🏷️' : (type === 'group' ? '👥' : '👤')}
      </span>
      <span style={{ fontWeight: '600' }}>
        {groupName || phone}
      </span>
      {reason && (
        <span style={{ color: '#6b7280', fontSize: '0.8rem' }}>
          - {reason}
        </span>
      )}
      <button
        onClick={onRemove}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '0.1rem',
          marginLeft: '0.25rem',
          fontSize: '1rem',
          color: '#6b7280',
          lineHeight: 1
        }}
        title="Remove exclusion"
        onMouseEnter={(e) => e.currentTarget.style.color = '#ef4444'}
        onMouseLeave={(e) => e.currentTarget.style.color = '#6b7280'}
      >
        ×
      </button>
    </div>
  );
};
